import { DataAttributeObject } from './types';

/**
 * Typeguard for DataAttributeObject
 */
export const isDataAttributeObject = (object: any): object is DataAttributeObject => !!object && typeof object === 'object' && typeof object.value === 'string';
